module.exports = __webpack_public_path__ + "img/Group 967t3.dc583da6.svg";